import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';

import { ApplicationPreloadService } from 'projects/admin/src/app/service/application-preload.service';
import { IAuthStore } from 'shared/auth/store/auth.reducer';
import { HelloWebService } from 'shared/openapi/services/hello-web.service';
import { LogoutService } from 'shared/openapi/services/logout.service';
import { RefreshSessionService } from 'shared/openapi/services/refresh-session.service';
import { InternalAuthBaseService } from 'shared/services/internal-auth-base.service';
import { LoggerService } from 'shared/services/logger.service';

@Injectable({
	providedIn: 'root',
})
export class AdminInternalAuthService extends InternalAuthBaseService {
	constructor(
		logger: LoggerService,
		dialog: MatDialog,
		router: Router,
		store: Store<{ auth: IAuthStore }>,
		helloService: HelloWebService,
		logoutService: LogoutService,
		refreshSessionService: RefreshSessionService,
		cookieService: CookieService,
		private applicationPreloadService: ApplicationPreloadService
	) {
		super(logger, dialog, router, store, helloService, logoutService, refreshSessionService, cookieService);
	}

	public override preload(): Promise<void> {
		return this.applicationPreloadService.preload();
	}
}
